import './App.css';
import { Stamp }                        from '@utils';
import Router                           from './router/Router'
import { useIdleTimer }                 from 'react-idle-timer' 
import { useEffect }                    from 'react';
import { Beforeunload }                 from 'react-beforeunload';

const App = () => {
    Stamp()

    const onPrompt = () => {
    }

    const onIdle = () => {
        const d = new Date();
        let time = d.getTime();

        if(window.localStorage.getItem("userData") != null) {
            window.localStorage.removeItem("token")
            window.localStorage.removeItem("userData")
            window.localStorage.removeItem("menu")
            window.location.reload()
        }
    }

    const onActive = (event) => {
    }

    const onAction = (event) => {
    }

    const beforeUnLoad = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.returnValue = '';
    }

    const {
        start,
        reset,
        activate,
        pause,
        resume,
        isIdle,
        isPrompted,
        getTabId,
    } = useIdleTimer({
        onPrompt,
        onIdle,
        onActive,
        onAction,
        timeout: 1000 * 60 * 10,
        promptTimeout: 0,
        events: [
            'mousemove',
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown',
            'MSPointerMove',
            'visibilitychange'
        ],
        startOnMount: true,
        startManually: false,
        stopOnIdle: false,
        crossTab: true,
        name: 'idle-timer',
        syncTimers: 0,
    })

    return (
        <>
            <Router />
        </>
    )
}
export default App;
